import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobsDelete = {
    path: "/jobs",
    method: RouteHttpVerb.DELETE
};
export { locationRestJobsDelete };
